export const apiVersion = {
  one: 1,
  two: 2,
};

export const apiVersionUrlSegment = {
  versionOne: '/api/v1',
  versionTwo: '/api/v2',
};
